export const initializeEvents = () => {
  const blocks = document.querySelectorAll('[data-component="events"]')

  blocks.forEach(block => {
    const perPage = parseInt(block.dataset.perPage, 10) || 2
    const cards = Array.from(block.querySelectorAll('[data-component="events-card"]'))
    const loadMoreButton = block.querySelector('[data-component="events-load-more"]')
    const loadMoreWrap = block.querySelector('[data-component="events-load-more-wrap"]')

    let shownCount = perPage

    const render = () => {
      cards.forEach((card, index) => {
        card.classList.toggle('hidden', index >= shownCount)
      })

      if (loadMoreWrap) {
        loadMoreWrap.classList.toggle('hidden', shownCount >= cards.length)
      }
    }

    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', () => {
        shownCount += perPage
        render()
      })
    }

    render()
  })
}
